

































































import { Component, Prop, Mixins } from "vue-property-decorator";
import FetchStats from "@/components/app/global/stats/stat/_fetchStatsMixin";
import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import { IStatRange } from "@/models/stats";
import StatsStorageMixin from "@/mixins/statsStorageMixin";
import dateranges from "@/data/dateranges";

@Component({
  components: {
    "stat-view": () => import("@/components/app/global/stats/stat/statView.vue")
  }
})
export default class Stat extends Mixins(
  FetchStats,
  StatsStorageMixin,
  Context
) {
  // Props
  @Prop({ default: 0 })
  public declare defaultValue: any;

  @Prop({ default: null })
  public dateFrom!: Date;

  @Prop({ default: null })
  public dateTo!: Date;

  @Prop({ default: null })
  public label!: string;

  @Prop({ default: "div" })
  public component!: string;

  @Prop({ default: null })
  public to!: any;

  @Prop({ default: null })
  public tooltipMessage!: string;

  @Prop({ default: null })
  public tooltipMessageSubheader!: string;

  // Getters
  public get hasValueSlot() {
    return !!this.$slots["value"] || !!this.$scopedSlots["value"];
  }

  public get hasDates() {
    return !!this.dateFrom || !!this.dateTo;
  }

  public get isFirstDateOnly() {
    return this.dateFrom && !this.dateTo;
  }

  public get isLastDateOnly() {
    return !this.dateFrom && this.dateTo;
  }

  public get firstDate() {
    return this.dateFrom;
  }

  public get lastDate() {
    return this.dateTo;
  }

  public get dateText() {
    const m = this.$moment;
    const df = this.dateFormat as string;

    if (this.dateFrom && this.dateTo)
      return `${m(this.dateFrom).format(df)} - ${m(this.dateTo).format(df)}`;
    if (this.isFirstDateOnly) return `${m(this.dateFrom).format(df)}`;
    if (this.isLastDateOnly)
      return this.$t("_.until_date", { date: m(this.dateTo).format(df) });
    return "";
  }

  public get activeDateRange() {
    return this.$_.find(dateranges.ranges, option => {
      const [date1, date2] = [option.dateFrom, option.dateTo];
      return (
        this.$moment(date1).isSame(this.firstDate, "day") &&
        this.$moment(date2).isSame(this.lastDate, "day")
      );
    });
  }

  public get dateFormat() {
    if (this.isFirstDateOnly) return this.$t("_datetime.date.long");
    const isSameYear = this.$moment(this.firstDate).isSame(
      this.lastDate,
      "year"
    );
    return isSameYear
      ? this.$t("_datetime.month.short")
      : this.$t("_datetime.date.long");
  }

  // Methods
  public openDateModal() {
    if (this.isFirstDateOnly || this.isLastDateOnly)
      return this.openStatSingleDateModal();
    this.openDateRangeModal();
  }

  public openDateRangeModal() {
    this.$store.dispatch(`data/${DataModules.STATS}/openDateRangeModal`, {
      config: {
        props: {
          dateFrom: this.dateFrom,
          dateTo: this.dateTo
        },
        events: {
          update: (result: IStatRange) => {
            this.$emit("range-change", result);
            this.trySetStatDateToStorage(result);
          }
        }
      }
    });
  }

  public openStatSingleDateModal() {
    const date = this.isFirstDateOnly
      ? this.firstDate
      : this.isLastDateOnly
      ? this.dateTo
      : {};

    this.$store.dispatch(`data/${DataModules.STATS}/openStatSingleDateModal`, {
      config: {
        props: {
          title: this.$t("_.select_date"),
          defaultDate: date,
          minDate: null,
          onSelect: async newDate => {
            const result = {
              ...(this.isFirstDateOnly
                ? { dateFrom: newDate }
                : this.isLastDateOnly
                ? { dateTo: newDate }
                : {})
            } as IStatRange;
            this.$emit("range-change", result);
          }
        }
      }
    });
  }
}
